export default class CompareToNotEqual {
  constructor() {
    'ngInject';

    this.require = 'ngModel';
    this.restrict = 'A';
    this.scope = {
      otherModelValue: '=compareToNotEqual'
    };
  }

  link($scope, element, attrs, ctrl) {
    $scope.$watch('otherModelValue', () => {
      ctrl.$validate();
    });

    ctrl.$validators.compareToNotEqual = modelValue =>
      modelValue !== $scope.otherModelValue;
  }

  static directiveFactory() {
    'ngInject';

    return new CompareToNotEqual();
  }
}



// WEBPACK FOOTER //
// ./common/directives/validation/compare-to-not-equal.js